














import { LearningPathV2 } from 'frontend/types/learningPathV2';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class Header extends Vue {
  @Prop({ type: Object, required: true })
  private learningPath!: LearningPathV2;
  @Prop({ type: Boolean, required: false, default: false })
  private hideStats!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  private isRecommending!: boolean;

  private get stats(): Array<{ num: number; description: string }> {
    const { levels } = this.learningPath;
    const courses = levels.reduce((sum, level) => sum + level.courses.length, 0);
    return [
      { num: levels.length, description: levels.length > 1 ? 'Levels' : 'Level' },
      { num: courses, description: courses > 1 ? 'Courses' : 'Course' },
    ];
  }
}
